// "Gợi ý bài tập liên quan" for a period. Split out of AfterLessonReminderForm so the list can be
// pinned by a test - a repeated row there reads as one checkbox ticking two.

import type { IztContentNode } from '../../api/types';
import type { ReminderHomeworkSuggestion } from '../../config/reminder-presets.ts';

// the tree only promises "non-null"; a count is shown when the payload actually carries one
export function questionCount(value: unknown): number | undefined {
  // the fixture and the real tree both answer with a bare count, which the object branch dropped
  if (typeof value === 'number') return isFinite(value) && value > 0 ? value : undefined;
  if (Array.isArray(value)) return value.length;
  if (!value || typeof value !== 'object') return undefined;
  const shape = value as { length?: number; count?: number; total?: number };
  if (typeof shape.length === 'number') return shape.length;
  if (typeof shape.count === 'number') return shape.count;
  if (typeof shape.total === 'number') return shape.total;
  return undefined;
}

/** The period's own course only. /izt-content/tree answers with the whole catalogue, the requested
    subject first, so walking all of it offered every other subject's exams as well - four of them
    named "Đề kiểm tra giữa kỳ I". Ids are deduped too, so a repeated unit can never draw twice. */
export function homeworkSuggestions(tree: IztContentNode[]): ReminderHomeworkSuggestion[] {
  const list: ReminderHomeworkSuggestion[] = [];
  const seen: string[] = [];
  const sections = tree.length > 0 ? tree[0].sections || [] : [];
  for (let s = 0; s < sections.length; s += 1) {
    const units = sections[s].units || [];
    for (let u = 0; u < units.length; u += 1) {
      const unit = units[u];
      if (unit.homeworkQuestion === null || unit.homeworkQuestion === undefined) continue;
      if (seen.indexOf(unit.id) >= 0) continue;
      seen.push(unit.id);
      list.push({ id: unit.id, name: unit.name, questionCount: questionCount(unit.homeworkQuestion) });
    }
  }
  // a course with no homework-bearing unit offers nothing; the form says so
  return list;
}
